import { useCallback, useContext } from 'react';
import { useRouter } from 'next/router';

import { BookingContext } from '../../shared/contexts/Booking.context';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';

export default function GoBack() {
  const router = useRouter();
  const { state: bookingContextState, actions: bookingContextActions } = useContext(BookingContext);
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { state: theme } = useContext(ThemeContext);

  const guestDataStep =
    bookingContextState?.guestForms?.findIndex(f => f === 'GuestFormDataWrapper') + 1 || 1; //default 1
  const contractsStep =
    bookingContextState.guestForms?.findIndex(f => f === 'GuestFormSeeContracts') + 1 || 7; //default 7;
  const confirmStep =
    bookingContextState.guestForms?.findIndex(f => f === 'GuestFormConfirm') + 1 || 8; //default 8;
  const upgradeStep =
    bookingContextState.guestForms?.findIndex(f => f === 'GuestFormRoomUpgrade') + 1 || 3; //default 3;
  const upsellStep =
    bookingContextState.guestForms?.findIndex(f => f === 'GuestFormUpsell') + 1 || 4; //default 4;

  const handleClick = useCallback(() => {
    const {
      hotelId,
      bookingToCheckin,
      bookings,
      checkinRequirements,
      bookingCustomParameters,
      upsellV2RoomDetailVisible,
      crossSellV2ItemDetailVisible,
    } = bookingContextState;

    if (hotelId) {
      let route = '/hotel/[hotelId]/';
      let as = route.replace('[hotelId]', hotelId);

      const startCheckin = 'startCheckin/[bookingIdentifier]';
      const booking = bookingToCheckin || checkinRequirements?.booking;
      if (booking) {
        const guestForm = 'guestForm/[checkinGuestId]';

        if (router.route === `${route}${guestForm}`) {
          let step = null;
          try {
            step = parseInt(new URLSearchParams(window.location.search).get('step'));
          } catch (e) {}
          if (step > 1) {
            let newStep = null;
            if (step == contractsStep) {
              newStep = guestDataStep;
            } else if (step == confirmStep) {
              newStep = contractsStep;
            } else if (step == upgradeStep) {
              if (!!upsellV2RoomDetailVisible) {
                // control room detail visible
                bookingContextActions.setUpsellV2RoomDetailVisible(false);
                return;
              } else {
                newStep = guestDataStep;
              }
            } else if (step == upsellStep) {
              if (!!crossSellV2ItemDetailVisible) {
                // control item detail visible
                bookingContextActions.setCrossSellV2ItemDetailVisible(false);
                return;
              } else {
                newStep = guestDataStep;
              }
            } else {
              newStep = step - 1;
            }
            return router.replace(
              `${route}${guestForm}`,
              `${window.location.pathname}?step=${newStep}`
            );
          } else {
            route += `${startCheckin}`;
            as += startCheckin;

            const bookingToGoBack = booking.uuid;
            as = as.replace('[bookingIdentifier]', bookingToGoBack);

            if (bookingCustomParameters['allGuests']) {
              var queryString = Object.keys(bookingCustomParameters['allGuests'])
                .map(key => key + '=' + bookingCustomParameters['allGuests'][key])
                .join('&');
              as += `?${queryString}`;
            }
          }
        } else if (`${route}${startCheckin}`.includes(router.route)) {
          if (bookings?.length > 1) {
            route += 'bookingSearch';
            as += 'bookingSearch';
          } else {
            route += 'bookingSearchForm';
            as += 'bookingSearchForm';
          }
        } else if (router.route === `${route}bookingSearchForm`) {
          route += 'languages';
          as += 'languages';
          router.push(route, as);
        } else if (router.route === `${route}bookingSearch`) {
          route += 'bookingSearchForm';
          as += 'bookingSearchForm';
          router.push(route, as);
        } else return router.back();
      } else if (
        router.route === `${route}${startCheckin}` ||
        router.route === `${route}bookingSearch`
      ) {
        route += 'bookingSearchForm';
        as += 'bookingSearchForm';
      } else return router.back();
      router.push(route, as);
    } else return router.back();
  }, [bookingContextState.upsellV2RoomDetailVisible]);

  return (
    <>
      <button className={'button'} onClick={handleClick}>
        {translate('back')}
      </button>

      <style jsx>{`
        .button {
          background: white;
          color: ${theme.mainColor};
          padding: 5px 10px;
          border: 1px solid ${theme.mainColor};
          border-radius: 50px;
          font-size: 15px;
          line-height: 30px;
          cursor: pointer;
        }
      `}</style>
    </>
  );
}
